import React from 'react';
import styled, { StylesProps, cx } from '../../../../lib/styles';
import lightDestinationStyles from './LightDestination_styles';
import Spacer from '../../../../components/presentational/Spacer';
import withImgix from '../../../../lib/imgix';
import { Destination } from '../../../../models/travelCollection';

type Size = 's' | 'm' | 'l' | 'xl';

export interface LightDestinationProps {
  destination: Destination;
  size: Size;
}

const rowGaps = {
  m: 'xs',
  l: 's',
  xl: 's',
};

const LightDestination = ({
  destination: { URL, title, imageURL },
  size = 'm',
  styles,
}: LightDestinationProps & StylesProps<typeof lightDestinationStyles>) => {
  const containerProps = { className: styles.link, href: URL, title };

  const content = (
    <Spacer row space={rowGaps[size] || rowGaps.m} className={styles.author}>
      <div
        className={styles.avatar}
        style={{
          backgroundImage: `url("${withImgix(imageURL, { w: 90, h: 90 })}")`,
        }}
      />

      <Spacer space={'xxs'} align={'flex-start'}>
        <span className={cx(styles.authorName, 'StoryAuthor__name')}>
          {title}
        </span>
      </Spacer>
    </Spacer>
  );

  return <a {...containerProps}>{content}</a>;
};

export default styled(lightDestinationStyles)(LightDestination);
